// Import model
import { CreatePickListRequest } from '../models/CreatePickListRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreatePickListRequest - handles JSON serialization and deserialization with type validation
 */
export class CreatePickListRequestSerializer {
  /**
   * Deserializes a JSON string into a CreatePickListRequest instance
   */
  static deserialize(json: string): CreatePickListRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreatePickListRequest instance
   */
  static fromObject(obj: any): CreatePickListRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreatePickListRequest');
    }


    const instance: CreatePickListRequest = {
      isActive: obj['isActive'] as boolean | undefined,
      parentObjectId: obj['parentObjectId'] as string | undefined,
      parentObjectType: obj['parentObjectType'] as string | undefined,
      tags: obj['tags'] ? (obj['tags'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      bins: obj['bins'] ? (obj['bins'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      description: obj['description'] as string | undefined,
      name: obj['name'] as string,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreatePickListRequest instances
   */
  static deserializeArray(json: string): CreatePickListRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreatePickListRequest instance to a JSON string
   */
  static serialize(instance: CreatePickListRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreatePickListRequest instance to a plain object
   */
  static toObject(instance: CreatePickListRequest): any {
    return {
      'isActive': instance.isActive,
      'parentObjectId': instance.parentObjectId,
      'parentObjectType': instance.parentObjectType,
      'tags': instance.tags?.map((item: any) =>
        item
      ),
      'bins': instance.bins?.map((item: any) =>
        item
      ),
      'description': instance.description,
      'name': instance.name,
    };
  }

  /**
   * Serializes an array of CreatePickListRequest instances to a JSON string
   */
  static serializeArray(instances: CreatePickListRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
